jQuery(document).ready(function ($) {

    /**
     * parent ajax class that makes ajaxing easier; Ajax is for forms, and AjaxCode is for code. 
     * later on we can refactor into one class or into multiple child classes. didn't do it yet
     * because of all the places Ajax is called, will take some time to find them all. 
     */
    class Ajax {

        constructor(formData) {
            if (formData === undefined) {
                throw new Error("formData is required constructor argument for Ajax class");
            }
            this.type = "POST";
            this.dataType = "json";
            this.url = ajax_object.ajax_url;
            this.data = formData;
            this.processData = false;
            this.contentType = false;
            this.formElement = $("<div></div>");
            this.messageElement = $("<div></div>");
            this.buttonClicked = $("<div></div>");
        }

        setFormData(formData) {
            this.data = formData;
        }

        call(success = function () { }, error = function () { }) {
            var _this = this;
            if (_this.formElement.hasClass("disabled")) {
                return;
            }
            _this.formElement.addClass("disabled", true);
            $.ajax({
                type: _this.type,
                url: _this.url,
                data: _this.data,
                dataType: _this.dataType,
                processData: _this.processData,
                contentType: _this.contentType,
                success: function (data) {
                    _this.messageElement.text(data.message);
                    _this.formElement.removeClass("disabled");
                    success(data);
                },
                error: function (a, b, c) {
                    error(a, b, c);
                    //console.log(b, c);
                }
            });
        }
        
    }

    class AjaxForm extends Ajax {
        constructor(formData) {
            super(formData);
        }
    }

    class AjaxCode extends Ajax {
        constructor(data) {
            super(data);
            if (data === undefined) {
                throw new Error("data is required constructor argument for Ajax class");
            }
            this.type = "POST";
            this.url = ajax_object.ajax_url;
            this.data = data;
            this.dataType = "json";
        }

        call(success = function () { }, error = function () { }) {
            var _this = this;
            $.ajax({
                type: _this.type,
                url: _this.url,
                data: _this.data,
                success: function (d) {
                    success(d);
                },
                error: function (a, b, c) {
                    error(a, b, c);
                    //console.log(b, c);
                }
            });
        }
    }

    window.AjaxCode = AjaxCode;
    window.AjaxForm = AjaxForm;

    window.Ajax = function (formData) {
        console.error("Ajax has been moved to AjaxForm. use ajaxform instead.");
        return new AjaxForm(formData);
    }


});




